import moment from 'moment'
import React from 'react'
import { translate } from '../../utils/useful'
// import { checkTextTranslation } from '../../utils/useful'

class TableDateTimeInput extends React.Component {
    state = {
        week: ['mon', 'tu', 'we', 'th', 'fr', 'sa', 'su',],
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        let format = 'DD MMM YYYY hh:mm'
        // if (this.props.header.information?.showHour) {
        //     format = format + ' hh:mm'
        // }
        let color = null
        // console.log('this.props.data', this.props.data)
        // console.log('moment(Number(this.props.data)).isValid()', moment(this.props.data).isValid())
        if (true) {
            // color = '#c92f54'
        }
        return (
            <div className="w-100 h-100 flexcc" style={{ color }}>

                {(this.props.data && this.props.data != '' && moment(this.props.data).isValid()) ? (
                    <div className='w-100 flexc'>
                        {/* {console.log('trrrrrrrrrrrrrrrrue', moment(this.props.data).format(format))} */}
                        <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{moment(this.props.data).format(format)}</p>
                        {/* <p className="" style={{  textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{moment(Number(this.props.data)).format(format)} - {this.state.week[moment(Number(this.props.data)).day()]}</p> */}
                    </div>
                ) : (
                    <div className='flexc w-100'>
                        {/* {console.log('Number(this.props.data', this.props.data == 'undefined')} */}
                        {(!moment(this.props.data).isValid() && this.props.data == 'undefined') ? (
                            <p className=" w-100 " style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{translate("Invalid Date")}</p>
                        ) : (
                            <p className=" w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{translate("")}</p>
                        )}
                    </div>
                )}
            </div>
        )
    }
}

export default TableDateTimeInput;